import { Button } from "devextreme-react";

export default function DetailedCommentCell(props) {
  const { data } = props;

  const onClick = async (e) => {};

  return (
    <>
      {data.data.detailedCmt && data.data.detailedCmt.length > 0 && (
        <Button
          //   style={{ height: "20px" }}
          icon="fa-solid fa-comment"
          onClick={onClick}
        />
      )}
    </>
  );
}
